import styled from 'styled-components';

/**
 * Ошибка сохранения решения по находке — подписью над таблицей разметки
 * (`<caption>` растягивается на всю ширину таблицы при любом числе колонок).
 */
const Caption = styled.caption`
  caption-side: top;
  text-align: left;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  padding: ${({ theme }) => `${theme.spacing(2)} ${theme.spacing(3)}`};
  border-left: 3px solid ${({ theme }) => theme.colors.status.danger};
  background: ${({ theme }) => theme.colors.surface};
  color: ${({ theme }) => theme.colors.status.danger};
  font-size: 13px;
  line-height: 1.5;
`;

export function DecisionSaveCaption({ message }: { message: string | null }) {
  if (!message) return null;
  return <Caption role="alert">{message}</Caption>;
}
